export const AuthConstant = {
	AUTH_TOKEN: 's-token',
	AUTH_TOKEN_REFRESH: 's-token-refresh',
};
